import React, { Component } from 'react';
import firebase from 'firebase';
import { message } from 'antd';
import ProfileView from '../views/ProfileView';
import { base } from '../../base';

class ProfileContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPicture: false,
        };
        this.beforeUploadPicture = this.beforeUploadPicture.bind(this);
        this.updateProfilePicture = this.updateProfilePicture.bind(this);
        this.updateProfile = this.updateProfile.bind(this);
    }


    beforeUploadPicture(file) {
        const isJPG = file.type === 'image/jpeg';
        if (!isJPG) {
            message.error('You can only upload JPG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return false;
    }

    updateProfilePicture(info) {
        this.setState({ loadingPicture: true });

        const storageRef = firebase.storage().ref();
        const user = firebase.auth().currentUser;

        // const uploadFile = info.file.originFileObj;
        const fileName = `images/${user.uid}.jpg`;
        console.log(fileName);
        storageRef.child(fileName).put(info.file).then((snapshot) => {
            snapshot.ref.getDownloadURL().then((downloadURL) => {
                user.updateProfile({
                    photoURL: downloadURL,
                }).then(() => {
                    this.setState({
                        loadingPicture: false,
                    });
                }).catch((error) => {
                    console.log(error);
                    message.error('Error updating your profile picture');
                    this.setState({
                        loadingPicture: false,
                    });
                });
            });
        });
    }

    updateProfile(values) {
        const user = firebase.auth().currentUser;
        let updatedSuccess = true;
        user.updateProfile({
            displayName: values.name,
        }).then(() => {
        }).catch((error) => {
            updatedSuccess = false;
            console.log(error);
            message.error('Error updating your profile data');
        });

        base.update(`users/${this.props.extraUser.key}`, {
            data: {
                lang: values.language,
            },
            then(err) {
                if (err) {
                    updatedSuccess = false;
                }
                // TODO: make something on error
                // Router.transitionTo('dashboard');
            },
        });
        if (updatedSuccess) {
            message.success('Profile updated');
        }
        return this;
    }

    render() {
        return (
            <ProfileView
                uid={this.props.user.uid}
                name={this.props.user.displayName}
                profilePic={this.props.user.photoURL}
                email={this.props.user.email}
                company=""
                lang={this.props.extraUser.lang}
                loadingPicture={this.state.loadingPicture}
                beforeUploadPicture={this.beforeUploadPicture}
                updateProfilePicture={this.updateProfilePicture}
                updateProfile={this.updateProfile}
            />
        );
    }
}

export default ProfileContainer;



// WEBPACK FOOTER //
// ./src/components/containers/ProfileContainer.js